// インライン SVG の文字列。アイコンフォントも依存も足さずに済ませるため、
// 必要な形だけをここに置く。すべて currentColor で描き、サイズは CSS 側で決める。
// viewBox は 24x24 に統一しているので、どのアイコンも同じ寸法規則で並ぶ。

function svg(body: string, extraAttrs = ""): string {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"${extraAttrs ? ` ${extraAttrs}` : ""}>${body}</svg>`;
}

/** ブランドロゴ: 山の稜線の手前に建つ小さな家。塗りで描くので stroke 版とは別扱いにする。 */
export const ICON_LOGO = `<svg viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false" class="brand-logo">
  <path d="M2 25.5 L10.5 12 L16 20 L21 13 L30 25.5 Z" fill="currentColor" opacity=".28" />
  <path d="M16 4.5 L25 11.5 V26 H7 V11.5 Z" fill="var(--surface-solid, #fff)" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
  <path d="M13.5 26 v-6.5 h5 V26" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
</svg>`;

export const ICON_SEARCH = svg(`<circle cx="11" cy="11" r="6.5" /><path d="m16.2 16.2 4.3 4.3" />`);

export const ICON_STAR = svg(
  `<path d="m12 3.6 2.6 5.3 5.8.85-4.2 4.1 1 5.75L12 16.9l-5.2 2.7 1-5.75-4.2-4.1 5.8-.85z" />`,
);

export const ICON_STAR_FILLED = svg(
  `<path d="m12 3.6 2.6 5.3 5.8.85-4.2 4.1 1 5.75L12 16.9l-5.2 2.7 1-5.75-4.2-4.1 5.8-.85z" fill="currentColor" />`,
);

export const ICON_SHARE = svg(
  `<circle cx="17.5" cy="6" r="2.8" /><circle cx="6.5" cy="12" r="2.8" /><circle cx="17.5" cy="18" r="2.8" /><path d="m9 10.7 6-3.3M9 13.3l6 3.3" />`,
);

export const ICON_CLOSE = svg(`<path d="m6.5 6.5 11 11m0-11-11 11" />`);

export const ICON_SUN = svg(
  `<circle cx="12" cy="12" r="4.2" /><path d="M12 2.8v2.4M12 18.8v2.4M2.8 12h2.4M18.8 12h2.4M5.5 5.5l1.7 1.7M16.8 16.8l1.7 1.7M18.5 5.5l-1.7 1.7M7.2 16.8l-1.7 1.7" />`,
);

export const ICON_MOON = svg(`<path d="M20 14.2A8.2 8.2 0 0 1 9.8 4 8.4 8.4 0 1 0 20 14.2Z" />`);

export const ICON_CHEVRON = svg(`<path d="m9 5.5 6.5 6.5L9 18.5" />`);

const EXTERNAL_PATHS = `<path d="M14 4.5h5.5V10M19 5 11.5 12.5" /><path d="M17.5 14v4.5a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5V8A1.5 1.5 0 0 1 6 6.5h4.5" />`;

/** サイズは呼び出し側の CSS（`.source-title svg` 等）が決める。 */
export const ICON_EXTERNAL = svg(EXTERNAL_PATHS);

/**
 * 文章や箇条書きの中に置く外部リンクアイコン。SVG に内在サイズが無いので、
 * 親側のセレクタが無い場所では既定の 150x150 に伸びてしまう。
 * ここでだけは class を持たせ、`.ext-icon`（style.css）で文字サイズに合わせる。
 */
export const ICON_EXTERNAL_INLINE = svg(EXTERNAL_PATHS, `class="ext-icon"`);

export const ICON_ARROW_LEFT = svg(`<path d="M19 12H5.5m0 0 6-6m-6 6 6 6" />`);

export const ICON_LAYERS = svg(
  `<path d="m12 3.5 8.5 4.4-8.5 4.4L3.5 7.9z" /><path d="m4.6 12 7.4 3.9 7.4-3.9" /><path d="m4.6 16.1 7.4 3.9 7.4-3.9" />`,
);

export const ICON_FILTER = svg(`<path d="M4 6.2h16M7 12h10M10.5 17.8h3" />`);

export const ICON_LIST = svg(`<path d="M9 6.5h11M9 12h11M9 17.5h11" /><path d="M4.6 6.5h.01M4.6 12h.01M4.6 17.5h.01" stroke-width="2.4" />`);
